import { Link, useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { categories } from '@/mocks/siteData';

export default function Navbar() {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="text-2xl font-heading font-bold text-primary-600 group-hover:text-primary-500 transition-colors">
              po18
            </span>
            <span className="hidden sm:inline text-sm text-foreground-500 font-body">官方导航</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-label rounded-lg transition-colors whitespace-nowrap ${
                isActive('/')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <div className="relative group">
              <Link
                to="/category/yanqing"
                className={`px-4 py-2 text-sm font-label rounded-lg transition-colors whitespace-nowrap flex items-center gap-1 ${
                  location.pathname.startsWith('/category')
                    ? 'bg-primary-100 text-primary-700'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                分类浏览
                <i className="ri-arrow-down-s-line text-xs"></i>
              </Link>
              <div className="absolute top-full left-0 mt-1 w-48 bg-background-50 rounded-lg border border-background-200/70 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                {categories.map((cat) => (
                  <Link
                    key={cat.slug}
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-2 px-4 py-2.5 text-sm text-foreground-600 hover:text-primary-600 hover:bg-background-100 transition-colors first:rounded-t-lg last:rounded-b-lg"
                  >
                    <i className={`${cat.icon} text-base`}></i>
                    {cat.name}
                  </Link>
                ))}
              </div>
            </div>
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-label rounded-lg transition-colors whitespace-nowrap ${
                isActive('/about')
                  ? 'bg-primary-100 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <a
            href="https://www.po18.com"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="hidden md:inline-flex items-center gap-1.5 px-5 py-2 bg-primary-500 text-background-50 text-sm font-label font-medium rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            进入po18
            <i className="ri-arrow-right-up-line"></i>
          </a>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-b border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 rounded-lg">首页</Link>
            <div className="px-3 py-2 text-xs text-foreground-400 font-label">分类浏览</div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="flex items-center gap-2 pl-6 pr-3 py-2 text-sm text-foreground-600 hover:bg-background-100 rounded-lg"
              >
                <i className={`${cat.icon} text-base`}></i>
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-3 py-2.5 text-sm text-foreground-700 hover:bg-background-100 rounded-lg">关于我们</Link>
            <a href="https://www.po18.com" target="_blank" rel="nofollow noopener noreferrer" className="mt-2 mx-3 px-4 py-2.5 bg-primary-500 text-background-50 text-sm font-label font-medium rounded-lg text-center cursor-pointer">进入po18</a>
          </div>
        </div>
      )}
    </nav>
  );
}